import { Typography } from "@mui/material";
import React from "react";
import s from "./PageContainer.module.scss";
import c from "lib/style/colorVar.scss";
import errorSvg from "assets/Error.svg";
import { useTranslation } from "react-i18next";

const ErrorOverlay = ({ errorMessage }) => {
  const { t } = useTranslation();

  const getErrorMessage = () => {
    switch (errorMessage) {
      case true:
        return t("component.pageContainer.error.defaultDescription");
      case "networkError":
        return t("component.pageContainer.error.defaultDescription");
      default:
        return errorMessage;
    }
  };

  return (
    <div className={s["error-message-container"]}>
      <img src={errorSvg} alt="error" />
      <Typography variant="h1" color={c.brandDark64}>
        {t("component.pageContainer.error.title")}
      </Typography>
      <Typography variant="content-m" color={c.blackDark666}>
        {getErrorMessage()}
      </Typography>
    </div>
  );
};

export default ErrorOverlay;
